import { CONTACT_EMAIL } from '@/config/links'
import { useLanguage } from '@/context/LanguageContext'
import {Mail, Send} from 'lucide-react'
import { useState } from 'react'
import toast from 'react-hot-toast'

function Contact() {
  const { t } = useLanguage()
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [phone, setPhone] = useState('')
  const [message, setMessage] = useState('')

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()

    const subject = `Demande de devis - ${name || 'Nouveau contact'}`
    const bodyLines = [
      `Nom: ${name}`,
      `Email: ${email}`,
      phone ? `Téléphone: ${phone}` : '',
      '',
      message,
    ].filter(Boolean)

    const mailto = `mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(bodyLines.join('\n'))}`
    window.location.href = mailto
    toast.success(t.contact.success)
  }

  return (
    <section id="contact" className="bg-[#2b1c12] py-14">
      <div className="max-w-md mx-auto px-4">
        <div className="text-center mb-6">
          <h2 className="text-2xl font-bold text-amber-50 mb-2">
            {t.contact.title}
          </h2>
          <p className="text-amber-100/70 text-sm leading-relaxed">
            {t.contact.subtitle}
          </p>
        </div>

        <form
          onSubmit={handleSubmit}
          className="bg-[#3d2b1f] rounded-2xl p-5 border border-amber-800/30 space-y-3 animate-fade-in-up"
        >
          <div>
            <label htmlFor="name" className="block text-sm text-amber-100/80 mb-1.5">
              {t.contact.name}
            </label>
            <input
              id="name"
              type="text"
              required
              value={name}
              onChange={e => setName(e.target.value)}
              className="w-full rounded-lg bg-[#2b1c12] border border-amber-800/40 px-4 py-2.5 text-amber-50 placeholder-amber-100/30 focus:outline-none focus:ring-2 focus:ring-amber-500/60"
            />
          </div>

          <div>
            <label htmlFor="email" className="block text-sm text-amber-100/80 mb-1.5">
              {t.contact.email}
            </label>
            <input
              id="email"
              type="email"
              required
              value={email}
              onChange={e => setEmail(e.target.value)}
              className="w-full rounded-lg bg-[#2b1c12] border border-amber-800/40 px-4 py-2.5 text-amber-50 placeholder-amber-100/30 focus:outline-none focus:ring-2 focus:ring-amber-500/60"
            />
          </div>

          <div>
            <label htmlFor="phone" className="block text-sm text-amber-100/80 mb-1.5">
              {t.contact.phone}
            </label>
            <input
              id="phone"
              type="tel"
              value={phone}
              onChange={e => setPhone(e.target.value)}
              className="w-full rounded-lg bg-[#2b1c12] border border-amber-800/40 px-4 py-2.5 text-amber-50 placeholder-amber-100/30 focus:outline-none focus:ring-2 focus:ring-amber-500/60"
            />
          </div>

          <div>
            <label htmlFor="message" className="block text-sm text-amber-100/80 mb-1.5">
              {t.contact.message}
            </label>
            <textarea
              id="message"
              required
              rows={4}
              value={message}
              onChange={e => setMessage(e.target.value)}
              placeholder={t.contact.messagePlaceholder}
              className="w-full rounded-lg bg-[#2b1c12] border border-amber-800/40 px-4 py-2.5 text-amber-50 placeholder-amber-100/30 focus:outline-none focus:ring-2 focus:ring-amber-500/60 resize-none"
            />
          </div>

          <button
            type="submit"
            className="w-full flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-amber-500 text-[#2b1c12] font-semibold hover:bg-amber-400 transition-colors"
          >
            <Send className="w-4 h-4" />
            {t.contact.submit}
          </button>

          <p className="text-center text-sm text-amber-100/60 pt-1">
            {t.contact.direct}
            {' '}
            <a href={`mailto:${CONTACT_EMAIL}`} className="text-amber-400 font-medium inline-flex items-center gap-1 hover:underline">
              <Mail className="w-3.5 h-3.5" />
              {CONTACT_EMAIL}
            </a>
          </p>
        </form>
      </div>
    </section>
  )
}

export default Contact
